<template>
    <v-card>
        <v-toolbar dark class="cyan darken-3" v-if="showHeader">
            <v-toolbar-title>Lista de Presença</v-toolbar-title>
        </v-toolbar>
        <v-card-title class="pa-1" v-if="errors == false">
            <v-spacer></v-spacer>
            <v-btn fab dark small color="info" @click="loadAttendance">
                <v-icon dark>refresh</v-icon>
            </v-btn>
        </v-card-title>
        <v-data-table :headers="headers" :items="sortedItems" :pagination.sync="pagination" :loading="loading"
            :no-data-text="noData" :no-results-text="noResult" :rows-per-page-text="rowsPerPageT" hide-actions
            class="elevation-1" v-if="errors == false">
            <template slot="items" slot-scope="props">
                <tr :class="getPersonRowClass(props.item)">
                    <td v-if="$vuetify.breakpoint.mdAndUp">{{ props.item.role }}</td>
                    <td>
                        {{ props.item.name }}
                        <template v-if="!$vuetify.breakpoint.mdAndUp">
                            <br>
                            <v-chip
                                :color="props.item.present == '1' ? 'success' : props.item.present == '0' ? 'warning' : 'error'"
                                text-color="white">
                                {{ props.item.present == '1' ? 'Presente' : props.item.present == '0' ? 'Registro pendente'
                                : 'Ausente' }}
                            </v-chip>
                            <v-chip :color="props.item.certification ? 'success' : 'warning'" text-color="white"
                                v-if="props.item.present == '1'">
                                <template v-if="props.item.certification">
                                    <a :href="props.item.certification.url" target="_blank">Certificação concluída</a>
                                </template>
                                <template v-if="!props.item.certification">Certificação pendente</template>
                            </v-chip>
                        </template>
                    </td>
                    <td v-if="$vuetify.breakpoint.mdAndUp">
                        <v-chip
                            :color="props.item.present == '1' ? 'success' : props.item.present == '0' ? 'warning' : 'error'"
                            text-color="white">
                            {{ props.item.present == '1' ? 'Presente' : props.item.present == '0' ? 'Registro pendente'
                            : 'Ausente' }}
                        </v-chip>
                        <v-chip :color="props.item.certification ? 'success' : 'warning'" text-color="white"
                            v-if="props.item.present == '1'">
                            <template v-if="props.item.certification">
                                <a :href="props.item.certification.url" target="_blank">Certificação concluída</a>
                            </template>
                            <template v-if="!props.item.certification">Certificação pendente</template>
                        </v-chip>
                    </td>
                    <td align="center">
                        <v-btn color="success" floating small dark fab title="Registrar presença"
                            v-if="!readonly && props.item.present != '1'"
                            @click.stop="recordAttendance(props.item.id, true)">
                            <v-icon dark>check</v-icon>
                        </v-btn>
                        <v-btn color="error" floating small dark fab title="Registrar ausência"
                            v-if="!readonly && props.item.present != '' && !props.item.certification"
                            @click.stop="recordAttendance(props.item.id, false)">
                            <v-icon dark>cancel</v-icon>
                        </v-btn>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <v-card-title class="pa-1" v-if="!readonly && errors == false">
            <v-spacer></v-spacer>
            <v-text-field label="Código" v-model="newAttendanceId" @keyup.enter="addAttendance"
                prepend-icon="person"></v-text-field>
            <v-btn dark color="success" @click="addAttendance">
                <v-icon dark>add</v-icon> Adicionar ouvinte
            </v-btn>
        </v-card-title>
        <v-card-title class="pa-1" v-if="!readonly && errors == false">
            <v-spacer></v-spacer>
            <v-btn dark color="deep-orange" @click="certifyAttendees" v-if="canCertify && hasPendingCertification">
                <v-icon dark>check</v-icon> Certificar participantes presentes
            </v-btn>
            <v-alert color="info" :value="true" v-if="!canCertify && hasPendingCertification">A certificação dos
                participantes
                desta banca estará disponível após o encerramento.</v-alert>
        </v-card-title>
        <v-card-title v-if="errors != false">
            <v-alert error value="true" v-for="(error, idx) in errors" :key="'error_' + idx">
                {{ error }}
            </v-alert>
        </v-card-title>
        <v-card-title v-if="submitErrors != false">
            <v-alert error value="true" v-for="(error, idx) in submitErrors" :key="'error_' + idx">
                {{ error }}
            </v-alert>
        </v-card-title>
        <v-card-actions v-if="showActions">
            <slot name="actions"></slot>
        </v-card-actions>
    </v-card>
</template>

<script>
import { noData, noResult, rowsPerPageT } from './../locale/vuetify';

export default {
    name: 'ExamAttendance',
    props: {
        examId: {
            type: [Number, String],
            default: ''
        },
        showHeader: {
            type: [Boolean],
            default: true
        }
    },
    data() {
        return {
            allHeaders: [
                { text: 'Papel', align: 'left', value: 'role' },
                { text: 'Pessoa', align: 'left', value: 'person' },
                { text: 'Situação', align: 'left', value: 'status' },
                { text: 'Ações', align: 'center', value: 'actions' }
            ],
            attendanceList: {},
            pagination: {
                rowsPerPage: 300,
                sortBy: false
            },
            loading: false,
            noData: noData,
            noResult: noResult,
            rowsPerPageT: rowsPerPageT,
            showActions: false,
            errors: false,
            submitErrors: false,
            newAttendanceId: '',
            canCertify: false,
            hasPendingCertification: false,
            readonly: true
        }
    },
    computed: {
        // Computed para ajustar os headers com base no tamanho da tela
        headers() {
            // Se a tela for menor que 'md', a coluna 'role' será removida
            if (!this.$vuetify.breakpoint.mdAndUp) {
                return this.allHeaders.filter(header => header.value !== 'role' && header.value !== 'status');
            }
            return this.allHeaders;
        },
        sortedItems: function () {
            let items = []
            for (let person in this.attendanceList) {
                items.push(this.attendanceList[person])
            }
            items.sort(function (a, b) {
                var getRoleIdx = function (role) {
                    if (role == 'Presidente') return 0
                    if (role == 'Examinador') return 1
                    if (role == 'Examinador Suplente') return 2
                    return 3
                }
                let _a = ''.concat(getRoleIdx(a.role), a.name)
                let _b = ''.concat(getRoleIdx(b.role), b.name)

                if (_a > _b) {
                    return 1
                }

                if (_a < _b) {
                    return -1
                }
                // return _a > _b                  
            });
            return items
        }
    },
    methods: {
        init: function () { this.loadAttendance() },
        loadAttendance: function () {
            this.loading = true
            this.errors = false
            this.submitErrors = false
            this.readonly = true
            this.$http.post('attendanceList', { exam: this.examId }).then(response => {
                if (typeof response.data.status !== 'undefined' && response.data.status == 'ok') {
                    this.attendanceList = response.data.attendanceList
                    if (typeof response.data.perms !== 'undefined') {
                        this.readonly = (response.data.perms['edit'] == false)
                    }
                    this.loading = false
                } else {
                    console.log('Erro ao carregar lista de presença da banca ' + this.examId)
                }
            }, response => {
                if (typeof response.data.errors !== 'undefined') {
                    this.errors = response.data.errors
                }
                console.log('Erro ao carregar lista de presença da banca ' + this.examId)
            })
            this.canCertify = false
            this.hasPendingCertification = false
            this.$http.post('checkCertification', { exam: this.examId }).then(response => {
                if (typeof response.data.status !== 'undefined' && response.data.status == 'no_change') {
                    this.canCertify = true
                    for (let person of response.data.certifications) {
                        if (person.present && !person.certification) {
                            this.hasPendingCertification = true
                            break
                        }
                    }
                }
            }, response => {
                console.log('Erro ao verificar disponibilidade de certificação da banca ' + this.examId)
            })
        },
        getPersonRowClass: function (attendance) {
            if (attendance.present == '1') return 'green lighten-4'
            if (attendance.present == '0') return 'red lighten-4'
            return ''
        },
        recordAttendance: function (person, present) {
            this.submitErrors = false
            let recordAttendanceUrl = present ? 'recordAttendance' : 'unrecordAttendance'
            this.$http.post(recordAttendanceUrl, { exam: this.examId, person: person }).then(response => {
                if (typeof response.data.status !== 'undefined' && response.data.status == 'ok') {
                    this.newAttendanceId = ''
                    this.loadAttendance()
                } else {
                    console.log('Erro ao registrar presença para a banca ' + this.examId)
                }
            }, response => {
                if (typeof response.data.errors !== 'undefined') {
                    this.submitErrors = response.data.errors
                }
                console.log('Erro ao registrar presença para a banca ' + this.examId)
            })
        },
        addAttendance: function () {
            this.recordAttendance(this.newAttendanceId, true)
        },
        certifyAttendees: function () {
            this.submitErrors = false
            this.$http.post('certify', { exam: this.examId }).then(response => {
                if (typeof response.data.status !== 'undefined' && response.data.status == 'ok') {
                    this.loadAttendance()
                } else {
                    console.log('Erro ao certificar participantes presentes da banca ' + this.examId)
                }
            }, response => {
                if (typeof response.data.errors !== 'undefined') {
                    this.submitErrors = response.data.errors
                }
                console.log('Erro ao certificar participantes presentes da banca ' + this.examId)
            })
        }
    },
    watch: {
        examId: function (newValue) {
            this.init()
        }
    },
    created: function () {
        this.showActions = typeof this.$slots['actions'] !== 'undefined'
        this.init()
    }
}

</script>

<style scoped>
/* Aqui, a classe é usada para controlar a exibição com base em media queries. */
@media (max-width: 600px) {
    .hide-on-mobile {
        display: none !important;
    }
}
</style>


// WEBPACK FOOTER //
// ExamAttendance.vue?6f03e236